import React from "react";
import Footer from "../footer/Footer";
import VTDancerSelection from "../page/VTDancerSelection";
import Header from "../header/Header";

export default function LandingDancerSelections({page}) {
    return (
        <>
            <Header headerType="AdminModeratorOnly"/>
            <VTDancerSelection/>
            <Footer/>
        </>
    );
}